export default [
	{
		path: '/users',
		name: 'users',
		component: () => import('@/views/User/Users.vue'),
		meta: { requiresAuth: true, permission: 'view_users' }
	},
	{
		path: '/users/admins',
		name: 'users.admins',
		component: () => import('@/views/User/Admins.vue'),
		meta: { requiresAuth: true, permission: 'view_admins' }
	},
	{
		path: '/users/agents/state',
		name: 'users.agents.state',
		component: () => import('@/views/User/StateAgents.vue'),
		meta: { requiresAuth: true, permission: 'view_state_agents' }
	},
	{
		path: '/users/agents/agency',
		name: 'users.agents.agency',
		component: () => import('@/views/User/AgencyAgents.vue'),
		meta: { requiresAuth: true, permission: 'view_agency_agents' }
	},
	{
		path: '/users/create',
		name: 'users.create',
		component: () => import('@/views/User/CreateUser.vue'),
		meta: { requiresAuth: true, permission: 'create_user' }
	}
]
